// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__MxuJY","title":"ClientCherryInfo_title__3ACNf","itemText":"ClientCherryInfo_itemText__391GU"};